import { Link } from 'react-router-dom';
import { getFeaturedMovies } from '@/mocks/movies';

export default function HeroBanner() {
  const featuredMovies = getFeaturedMovies();
  const [currentIndex, setCurrentIndex] = useState(0);
  const currentMovie = featuredMovies[currentIndex] || featuredMovies[0];

  useEffect(() => {
    if (featuredMovies.length <= 1) return;
    const timer = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % featuredMovies.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [featuredMovies.length]);

  if (!currentMovie) return null;

  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={currentMovie.poster}
          alt={currentMovie.title}
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/60 via-foreground-950/30 to-foreground-950/80"></div>
      </div>

      <div className="absolute inset-0 flex items-center">
        <div className="w-full px-4 md:px-6">
          <div className="max-w-[1280px] mx-auto w-full">
            <div className="max-w-2xl">
              <div className="flex items-center gap-2 mb-3">
                <span className="px-3 py-1 rounded-full bg-primary-500/90 text-background-50 text-xs font-semibold whitespace-nowrap">
                  {currentMovie.categoryLabel}
                </span>
                {currentMovie.isHot && (
                  <span className="px-3 py-1 rounded-full bg-accent-500/90 text-background-50 text-xs font-semibold whitespace-nowrap">
                    热播推荐
                  </span>
                )}
              </div>

              <h2 className="text-2xl md:text-4xl font-heading text-background-50 mb-3 leading-tight">
                {currentMovie.title}
              </h2>

              <p className="text-sm md:text-base text-background-200/90 mb-4 leading-relaxed line-clamp-2 md:line-clamp-3">
                {currentMovie.description}
              </p>

              <div className="flex items-center gap-3 mb-6">
                <div className="flex items-center gap-1">
                  <i className="ri-star-fill text-accent-500 text-sm"></i>
                  <span className="text-sm text-accent-400 font-semibold">{currentMovie.rating}</span>
                </div>
                <span className="text-background-400">|</span>
                <span className="text-sm text-background-300">{currentMovie.year}</span>
                <span className="text-background-400">|</span>
                <span className="text-sm text-background-300">{currentMovie.duration}</span>
              </div>

              <div className="flex items-center gap-3">
                <Link
                  to={`/article/${currentMovie.id}`}
                  className="px-6 py-2.5 rounded-lg bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-play-circle-line mr-1"></i>
                  立即观看
                </Link>
                <Link
                  to={`/category/${currentMovie.category}`}
                  className="px-6 py-2.5 rounded-lg bg-background-50/20 text-background-50 text-sm font-medium hover:bg-background-50/30 backdrop-blur-sm border border-background-50/20 transition-colors whitespace-nowrap cursor-pointer"
                >
                  更多{currentMovie.categoryLabel}
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      {featuredMovies.length > 1 && (
        <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex items-center gap-2">
          {featuredMovies.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentIndex(index)}
              className={`w-2 h-2 rounded-full transition-all cursor-pointer ${
                index === currentIndex
                  ? 'bg-primary-500 w-6'
                  : 'bg-background-50/50 hover:bg-background-50/80'
              }`}
            />
          ))}
        </div>
      )}
    </section>
  );
}